// 전역 텍스트 너비 캐시
const textWidthCache: Record<string, number> = {};

/**
 * 텍스트 너비 측정을 위한 유틸리티 함수
 * @param text - 측정할 텍스트
 * @param textElement - SVGTextElement
 * @returns 텍스트 너비
 */

export const measureTextWidth = (text: string, textElement: SVGTextElement | null): number => {
  if (!textElement) return 0;

  if (textWidthCache[text] !== undefined) {
    return textWidthCache[text];
  }

  textElement.textContent = text;
  const width = textElement.getBBox().width;
  textWidthCache[text] = width;

  return width;
};
